export const STATIC_ENTRIES_KEY = '$$staticEntries$$'
export const TRANSITIONAL_STATIC_ENTRIES_KEY = '$$transitionalStaticEntries$$'
export const STATIC_VALUE_ID = '$$STATIC_VALUE$$'
export const IMPORT_PROVIDER_METHOD_TYPE = 'createMany'
